module.exports = __webpack_public_path__ + "bc162866be7964527c34ed528c871e37.png";